import React, { useEffect } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";

const ShopifySucuessCallback = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const success = searchParams.get("success");
  const isSuccess = success === "1";

  useEffect(() => {
    const timer = setTimeout(() => {
      window.close();
      navigate("/integration/ShopifyIntegration");
    }, 2000);

    return () => clearTimeout(timer);
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100">
      <div className="bg-white shadow-lg rounded-2xl p-10 text-center w-[90%] max-w-md">

        <div className="flex items-center justify-center gap-4 mb-6">
          <img
            src="/assets/images/logo1.png"
            alt="App Logo"
            className="h-10 object-contain"
          />
          <span className="text-gray-400 text-lg">↔</span>
          <img
            src="/assets/images/Woo.svg"
            alt="WooCommerce"
            className="h-10 object-contain"
          />
        </div>


          <div className="text-green-500 text-5xl mb-4">🔗✅</div>

          <h1 className="text-2xl font-bold text-gray-800 mb-2">
            HELLO SHOPIFY YOU ARE Connected
          </h1>

          <p className="text-gray-500 mb-4">
            WHOOA YOU ARE CONNECTED
          </p>

          <p className="text-sm text-gray-400">
            Redirecting automatically...
          </p>

      </div>
    </div>
  );
};

export default ShopifySucuessCallback;